import { render, staticRenderFns } from "./GroupAnalyticsPrice.vue?vue&type=template&id=2ccff2e0&scoped=true&"
import script from "./GroupAnalyticsPrice.vue?vue&type=script&lang=js&"
export * from "./GroupAnalyticsPrice.vue?vue&type=script&lang=js&"
import style0 from "./GroupAnalyticsPrice.vue?vue&type=style&index=0&id=2ccff2e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccff2e0",
  null
  
)

export default component.exports